import Meta from '@/components/common/Meta'

import ShippingAndStorageServicesPage from '@/v2/components/pages/landing-pages/shipping-and-storage-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/shipping-and-storage-services-page'

interface ShippingAndStorageServicesPageProps {}

const Page: React.FC<ShippingAndStorageServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.shipping_and_storage_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.shipping_and_storage_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.shipping_and_storage_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ShippingAndStorageServicesPage />
    </>
  )
}

export default Page
